import { render, staticRenderFns } from "./BoxTime.vue?vue&type=template&id=651d885a&scoped=true&lang=pug"
import script from "./BoxTime.vue?vue&type=script&lang=js"
export * from "./BoxTime.vue?vue&type=script&lang=js"
import style0 from "./BoxTime.vue?vue&type=style&index=0&id=651d885a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "651d885a",
  null
  
)

export default component.exports